import { useState, useEffect } from "react";

//auth
import {
  useAuth
} from "../providers/auth";

//react-router-dom
import {
  useNavigate
} from "react-router-dom";

import openToast from "../utils/sweetAlert";

const useAxios = (configObj) => {
  //react-router-dom
  const navigate = useNavigate();

  //auth
  const {
    user,
    setUser
  } = useAuth();

  const {
    url,
    method,
    axiosInstance,
    requestConfig = {
      headers: {
        "Authorization": "Bearer " + user.token
      }
    }
  } = configObj;

  const [error, setError] = useState("");
  const [reload, setReload] = useState(0);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState([]);

  const refetch = () => setReload(prev => prev + 1);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      setError("");
      setLoading(true);

      try {
        const res = await axiosInstance[method.toLowerCase()](url, {
          ...requestConfig,
          signal: controller.signal
        });

        if(res.data.error) {
          openToast("info", "Atenção", res.data.message);
          return
        }

        setResponse(res.data);
      } catch (error) {

        console.log(error.response.data);

        if (error.response) {
          if (error.response.status === 401) {
            setUser({ id: "", name: "", token: "" });
            localStorage.removeItem("user");
            navigate("/", { replace: true });

            openToast("info", "Atenção", error.response.data.message);
          }
        }

        setError(error.message);
      } finally {
        setLoading(false);
      }
    }

    fetchData();

    return () => controller.abort();
  }, [reload]);

  return [response, setResponse, loading, error, refetch];
}

export default useAxios;